module.exports = __webpack_public_path__ + "img/cdv_trollface.d4891c0a.jpg";